"use client";

import * as React from "react";
import { Field } from "@chakra-ui/react";
import { PinInput } from "@chakra-ui/react";
import useControllable from "hooks/useControllable/useControllable";

export interface PinFieldProps {
  id: string;
  label?: string;
  value?: string;
  defaultValue?: string;
  length?: number;
  required?: boolean;
  helperText?: string;
  error?: string;
  onChange?: (value: string) => void;
}

export const PinField: React.FC<PinFieldProps> = (props) => {
  const { label, required, helperText, error, length = 4 } = props;

  const [value, setValue] = useControllable<string>({
    value: props.value,
    defaultValue: props.defaultValue ?? "",
    onChange: props.onChange,
  });
  const valueArray = React.useMemo(
    () => (value ?? "").slice(0, length).split(""),
    [value, length],
  );

  return (
    <Field.Root invalid={!!error} required={!!required}>
      {label && (
        <Field.Label>
          {label}
          {required && <Field.RequiredIndicator />}
        </Field.Label>
      )}

      <PinInput.Root
        value={valueArray}
        onValueChange={(val: any) => setValue(val)}
        name={props.id}
      >
        <PinInput.HiddenInput />
        <PinInput.Control>
          {Array.from({ length }).map((_, i) => (
            <PinInput.Input key={i} index={i} />
          ))}
        </PinInput.Control>
      </PinInput.Root>

      {error ? (
        <Field.ErrorText>{error}</Field.ErrorText>
      ) : helperText ? (
        <Field.HelperText>{helperText}</Field.HelperText>
      ) : null}
    </Field.Root>
  );
};
